import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  stopScrolling = true;
  constructor() {
  }

  ngOnInit() {
    // this.scrollToThis(1)
  }
  scrollToThis(height) {
    setTimeout(() => {
      window.scrollTo(0, 100);
      if (height > document.documentElement.scrollHeight) {
        this.stopScrolling = false;
      }
      if (this.stopScrolling)
        this.scrollToThis(height + 1)
    }, 1);
  }

}
